const {config} = require('../../../package.json');

const alias = (() => {
    return config.serviceProfile ? `/${config.serviceProfile}` : ""
})()

function getApiEndpoint() {
    return (config['isCloudDeployment'] && `https://prod.api.rev-lock.com${alias}`) || "http://localhost:3001"
}

const mstrWebUrl = (() => {
    return config.serviceProfile ? `https://prod-reports-${config.serviceProfile}.rev-lock.com` :
        "https://prod-reports.rev-lock.com"
})();

export default {
    microstrategy: {
        mstrWebUrl: `${mstrWebUrl}/MicroStrategy/servlet/`,
        project: 'Prod_RL_B',
        server: `prod-mstr.cluster.rev-lock.local`
    },
    hotGlue: {
        env_id: "prod.hotglue.rev-lock.com"
    },
    AWS: {
        "authenticationFlowType": "USER_PASSWORD_AUTH",
        API: {
            endpoints: [
                {
                    name: "revlock_api",
                    endpoint: getApiEndpoint()
                },
                {
                    name: "revlock_public_api",
                    endpoint: getApiEndpoint(),
                    custom_header: async () => {
                        return {'x-api-key': 'C6zNfde03c1OqCQNFsfYIa2SfmyImgIn8DqwZYvL'}
                    }
                }
            ]
        },
        Auth: {
            identityPoolId: "us-east-1:d0f08abf-65f1-40a0-abbe-e1d918f51cd8",
            region: "us-east-1",
            userPoolId: "us-east-1_Fdy2b5mSk",
            userPoolWebClientId: "1qg6sm77h56bieuo4uqljiqvl1",
            mandatorySignIn: true
        },
        Storage: {
            bucket: 'revlockprod-userfiles-mobilehub-615352475',
            region: 'us-east-1',
        },
        Analytics: {
            disabled: true
        },
        oauth: {
            domain: 'prod.auth.rev-lock.com',
            clientId: '1092057117597-5m0ml54tve0hha8v79pccob3l6320sno.apps.googleusercontent.com',
            redirectSignOut: 'https://app.rev-lock.com/signout',
            redirectSignIn: "https://app.rev-lock.com/",
            scope: ['email', 'profile', 'openid'],
            responseType: "code"
        }
    },
    analytics: {
        trackingId: "UA-127158128-2",
        debug: false
    }
};
